import { showToast } from "@/app/components/ui/Toast";

export function showWorkspaceSwitchToast(
  workspaceName: string | null | undefined,
): void {
  const name = workspaceName?.trim();
  if (!name) return;
  showToast(`สลับไปที่: ${name}`);
}
